import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(private http: HttpClient) {}

  getBadRequestErrors(error: { error: any }): string[] {
    const errors: string[] = [];
    const jsonObj: any = JSON.parse(JSON.stringify(error.error));
    for (const prop in jsonObj) {
      errors.push(jsonObj[prop].toString());
    }
    return errors;
  }

  fetch(url: string): Observable<any> {
    const assetPath = 'assets/data';
    return this.http
      .get(this.getBaseUrl() + assetPath + url)
      .pipe(map((data: any) => data.data || data));
  }

  private getBaseUrl(): string {
    return (
      location.protocol +
      '//' +
      location.hostname +
      (location.port ? ':' + location.port : '') +
      '/'
    );
  }
}
